import "./Spinner.css"
import EDSpan from "dom/elements/EDSpan.js"
import EDDiv from "dom/elements/EDSpan.js"

export default class Spinner extends EDDiv {

    constructor(p) {

        super(p)
        this.classList.add("ed-spinner")
        this.classList.add("ed-hidden")

        this.children.append(
            new EDSpan({
                class: "loader"
            })
        )

        window.addEventListener("spinnerEvent", (pEvt) => {
            
            if(pEvt.detail.id !== p.spinnerId) {
                return
            }
            
            if(pEvt.detail.cmd === "show") {

                this.classList.remove("ed-hidden")
                return
            }

            this.classList.add("ed-hidden")
        })
    }
}